import { LoadingSpinner } from '@components/LoadingSpinner.tsx';
import { Paths } from '@src/paths.ts';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys.ts';
import { useCallback, useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import authenticationService from '@src/api/services/AuthenticationService.ts';
import organizationService from '@src/api/services/OrganizationService.ts';

export default function OrganizationInviteAcceptView() {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const organizationId = useParams().organizationId;
  const token = searchParams.get(SearchParamKeys.TOKEN);
  if (!organizationId || !token) {
    throw new Error('Data is missing');
  }

  const hasRun = useRef(false);

  const acceptInvite = useCallback(() => {
    void (async () => {
      try {
        // Accept Invite
        await organizationService.acceptInvite(organizationId, token);
        // Refresh user to propagate the new role to the client
        await authenticationService.refresh();
        navigate(`${Paths.ORGANIZATIONS}/${organizationId}`);
      } catch {
        navigate(Paths.ROOT);
      }
    })();
  }, [navigate, organizationId, token]);

  useEffect(() => {
    if (!hasRun.current) {
      acceptInvite();
      hasRun.current = true;
    }
  }, [acceptInvite]);

  return <LoadingSpinner />;
}
